import type { EventBusPayload, EventHandler } from "./event-bus.type";

export const createEventBus = () => {
  const events = new Map<string, Set<EventHandler>>();

  const on = (event: string, handler: EventHandler) => {
    if (!events.has(event)) {
      events.set(event, new Set());
    }
    events.get(event)!.add(handler);
  };

  const off = (event: string, handler: EventHandler) => {
    events.get(event)?.delete(handler);
  };

  const emit = (event: string, payload: EventBusPayload) => {
    events.get(event)?.forEach((handler) => handler(payload));
  };

  return { on, off, emit };
};

export const eventBus = createEventBus();
